import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, withInterceptors, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideNativeDateAdapter } from '@angular/material/core';
import { routes } from './app.routes';
import { version } from './injectables';
import { environment } from 'src/environments/environment';
import { AuthService, WECHEER_ENVIRONMENT, WecheerAmplifyConfigService, tokenInterceptor } from 'wecheer-amplify';
import { API_USER_MANAGEMENT_BASE_URL } from './api/api-user-management.service.generated';
import { provideAnimations } from '@angular/platform-browser/animations';
import { API_CAMPAIGNS_BASE_URL } from './api/api-campaigns.service.generated';
import { API_REWARDS_BASE_URL } from './api/api-rewards.service.generated';
import { API_BAR_MANAGEMENT_BASE_URL } from './api/api-bar-management.service.generated';
import { API_IMAGE_CLASSIFICATION_BASE_URL } from './api/api-image-classification.service.generated';
import { API_DEVICE_MANAGEMENT_BASE_URL } from './api/api-device-management.service.generated';
import { API_ACCESS_MANAGEMENT_BASE_URL } from './api/api-access-management.service.generated';
import { HttpErrorInterceptor } from './common/services/http-error-interceptor';
import { ClarityService, provideClarityAnalytics } from 'wecheer-common';
import { provideMonacoEditor } from 'ngx-monaco-editor-v2';

export const appConfig: ApplicationConfig =
{
  providers: [
    provideHttpClient(
      withInterceptors([tokenInterceptor]),
      withInterceptorsFromDi()
    ),
    provideNativeDateAdapter(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideClarityAnalytics(environment.clarity),
    provideAppInitializer(() => {
      inject(ClarityService);
    }),
    { provide: version, useValue: environment.version },
    { provide: WECHEER_ENVIRONMENT, useValue: environment },
    { provide: API_CAMPAIGNS_BASE_URL, useValue: environment.apiCampaignsUrl },
    { provide: API_REWARDS_BASE_URL, useValue: environment.apiRewardsUrl },
    { provide: API_BAR_MANAGEMENT_BASE_URL, useValue: environment.apiBarManagementUrl },
    { provide: API_USER_MANAGEMENT_BASE_URL, useValue: environment.apiUserManagementUrl },
    { provide: API_IMAGE_CLASSIFICATION_BASE_URL, useValue: environment.apiImageClassificationUrl },
    { provide: API_DEVICE_MANAGEMENT_BASE_URL, useValue: environment.apiDeviceManagementUrl },
    { provide: API_ACCESS_MANAGEMENT_BASE_URL, useValue: environment.apiAccessManagementUrl },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    provideMonacoEditor({
      baseUrl: 'assets/monaco/min/vs'
    }),
    // Initialize Amplify config and token using the modern API
    provideAppInitializer(() => {
      const authService = inject(AuthService);
      const configService = inject(WecheerAmplifyConfigService);
      configService.setApiUserManagementUrl(environment.apiUserManagementUrl);
      authService.getAccessToken();
    }),
  ]
};
